import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

/**
 * Keeps the user's preferred_language column in sync with the UI language,
 * so server-side notifications (birthday / medical reminders) are localized.
 */
export const usePreferredLanguageSync = () => {
  const { i18n } = useTranslation();
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.id) return;

    let cancelled = false;

    const sync = async (lng: string) => {
      const language = (lng || 'en').split('-')[0];
      if (cancelled) return;
      try {
        await supabase.rpc('set_preferred_language', { _language: language });
      } catch (error) {
        console.warn('Could not sync preferred language:', error);
      }
    };

    sync(i18n.resolvedLanguage || i18n.language || 'en');
    i18n.on('languageChanged', sync);

    return () => {
      cancelled = true;
      i18n.off('languageChanged', sync);
    };
  }, [user?.id, i18n]);
};
